const ms = typeof window !== "undefined" && window.multipleSelect !== void 0 ? window.multipleSelect : { locales: {} };
export const Polish = {
  formatFilterPlaceholder() {
    return "Wprowad\u017A tekst, aby zaw\u0119zi\u0107 list\u0119";
  },
  formatSelectAll() {
    return "Wybierz wszystko";
  },
  formatAllSelected() {
    return "Wszystko";
  },
  formatCountSelected(count, total) {
    return `Wybrano ${count} z ${total}`;
  },
  formatNoMatchesFound() {
    return "Nie znaleziono";
  },
  formatOkButton() {
    return "OK";
  }
};
ms.locales["pl"] = Polish;
export default ms.locales;
